import {createSvgIcon} from '../create-svg-icon';

export const EqualizerIcon = createSvgIcon(
  <path d="M10 20h4V4h-4v16zm-6 0h4v-8H4v8zM16 9v11h4V9h-4z" />
, 'EqualizerOutlined');
